<template>
    <div class="document-container">
        <!-- 专利方案挖掘概述 -->
        <div class="section" style="margin-bottom: 60px;">
            <h2 class="section-title">专利方案挖掘概述</h2>
            <p class="section-content">
                “专利方案挖掘”是专加瓦平台的核心AI引擎之一，旨在帮助用户从零开始系统化地将一个模糊的想法转化为结构完整的技术交底书，实现“创意→交底书”的智能转化。
            </p>
        </div>

        <!-- 使用流程 -->
        <div class="section">
            <h2 class="section-title">专利方案挖掘使用流程</h2>

            <!-- 步骤一：进入模块 -->
            <div class="step">
                <h3 class="step-title">步骤一：进入模块</h3>
                <div class="sub-step-list">
                    <p>登录平台后，点击导航栏中的【专利方案挖掘】。</p>
                    <div class="imageInfo">
                        <img src="@/assets/userBook/image17.png" />
                    </div>
                    <p>进入后选择【链式推导交底书】，开始智能撰写流程。</p>
                    <div class="imageInfo">
                        <img src="@/assets/userBook/image16.png" />
                    </div>
                </div>
            </div>

            <!-- 步骤二：输入需求 -->
            <div class="step">
                <h3 class="step-title">步骤二：输入需求</h3>
                <div class="sub-step-list">
                    <p>在输入框中用一句话描述您的技术需求或创意想法。</p>
                    <div>
                        <p class="step-content example">示例：“开发一种新的无人机，能够在城市建筑密集区域实现精准快速避障移动”</p>
                    </div>
                    <div class="imageInfo">
                        <img src="@/assets/userBook/image15.png" />
                    </div>
                </div>
            </div>

            <!-- 步骤三：AI推演与交底书生成 -->
            <div class="step">
                <h3 class="step-title">步骤三：AI推演与交底书撰写</h3>
                <p class="step-content">系统将引导用户完成以下五个步骤，逐步将创意转化为结构化交底书：</p>

                <!-- 子步骤1：选题范围分析 -->
                <div class="sub-step">
                    <p class="sub-step-number">1、选题范围分析</p>
                    <div class="sub-step-list">
                        <p>系统将提供多个创新方向供用户选择，用户点击最符合需求的选项。</p>
                        <p>点击【下一步，确认场景及问题】继续。</p>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image14.png" />
                        </div>

                    </div>
                </div>

                <!-- 子步骤2：场景及问题确认 -->
                <div class="sub-step">
                    <p class="sub-step-number">2、场景及问题确认</p>
                    <div class="sub-step-list">
                        <p>系统识别与该选题相关的应用场景，并定义待解决的技术问题。</p>
                        <p>用户从约15个场景中选择最贴合实际应用的场景。</p>
                        <p>点击【下一步，选题分析】进入选题分析阶段。</p>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image13.png" />
                        </div>

                    </div>
                </div>

                <!-- 子步骤3：选题分析与初步方案 -->
                <div class="sub-step">
                    <p class="sub-step-number">3、选题分析与初步方案</p>
                    <div class="sub-step-list">
                        <p>AI提供初步解决方案构思，确认技术路径。</p>
                        <p>用户选择最合适的解决方案方向。</p>
                        <p>
                            点击【探索更多解决方案】，用户可选择更合适的可行性解决方案。
                        </p>
                        <p>
                            点击【下一步，方案细化】进入详细设计。
                        </p>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image12.png" />
                        </div>
                    </div>
                </div>

                <div class="sub-step">
                    <p class="sub-step-number">4、方案细化与步骤分解</p>

                    <div class="sub-step-list">
                        <div class="step-item">
                            <p class="step-text">（1）系统将方案拆解为逻辑清晰、环环相扣的技术实施步骤。</p>

                            <div class="imageInfo">
                                <img src="@/assets/userBook/image11.png" />
                            </div>

                            <div class="operation-list">
                                <p>点击【编辑】，可修改各章节标题及概述，修改完成后点击确定即可。</p>
                                <div class="imageInfo">
                                    <img src="@/assets/userBook/image10.png" />
                                </div>
                            </div>
                        </div>

                        <div class="step-item">
                            <p class="step-text">（2）用户可对每个子步骤进行以下操作：</p>
                            <div class="operation-list">
                                <p>点击【扩写详情】-【智能扩写】由AI补充细节。</p>
                                <p>选中子章节，点击【一键扩写】，即可撰写扩写详情。</p>
                                <div class="imageInfo">
                                    <img src="@/assets/userBook/image9.png" />
                                </div>
                                <div class="imageInfo">
                                    <img src="@/assets/userBook/image8.png" />
                                </div>
                                <p>点击【编辑】，手动编辑步骤内容。</p>
                                <p>在“修改意见”框中输入要求，点击【重新扩写】优化内容。</p>
                                <div class="imageInfo">
                                    <img src="@/assets/userBook/image7.png" />
                                </div>
                            </div>

                        </div>

                        <div class="step-item">
                            <p class="step-text">（3）完成所有步骤编辑后，点击【下一步，下载创新方案】</p>

                            <div class="imageInfo">
                                <img src="@/assets/userBook/image6.png" />
                            </div>
                        </div>
                    </div>
                </div>



                <div class="sub-step">
                    <p class="sub-step-number">5、交底书初稿撰写</p>
                    <div class="sub-step-list">

                        <p class="step-text">（1）点击撰写完整交底书，包含以下内容：技术领域、背景技术、解决的技术问题、保护发明点、有益效果、技术方案、应用前景等。</p>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image5.png" />
                        </div>

                        <p class="step-text">
                            （2）用户可点击每个章节旁的【撰写】按钮可撰写内容，点击【编辑】可更改相关内容
                        </p>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image4.png" />
                        </div>

                        <p class="step-text">
                            （3）全部章节编辑完成后，点击【下载交底书】导出为Word格式。
                        </p>
                        <p>
                            下载完专利交底书后，可点击继续【撰写专利五书】
                        </p>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image3.png" />
                        </div>

                    </div>
                </div>



                <div class="step">
                    <h3 class="step-title">步骤四：查看与下载</h3>
                    <div class="sub-step-list">
                        <p>系统撰写交底书后，用户可在线预览、编辑或下载撰写的交底书（Word格式）。</p>
                        <p>撰写内容支持后续导入其他模块（如权利要求书撰写、说明书撰写等）继续使用。</p>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image2.png" />
                        </div>
                        <div class="imageInfo">
                            <img src="@/assets/userBook/image1.png" />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PatentPlanMining',
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.document-container {
    max-width: 1000px;
    margin: 0 auto;
    // padding: 20px;
    font-family: "Microsoft YaHei", sans-serif;
    color: #000;
    line-height: 1.6;
}

.section {
    margin-bottom: 30px;
    padding-bottom: 15px;
}

.section {
    padding: 0px !important;
}

.section-title {
    // font-size: 20px;
    color: #000;
    // margin-bottom: 15px;
    // font-weight: 600;
}

.section-content {
    font-size: 16px;
    margin-top: 30px;
    margin-bottom: 30px;
    text-indent: 2em;

}

.step {
    // margin: 100px 0;
    margin-bottom: 150px;
}

.step-title {
    // font-size: 16px;
    color: #000;
    /* 步骤标题蓝色突出 */
    // margin: 15px 0 10px;
}

.step-content {
    font-size: 14px;
    margin-left: 10px;
}

.example {
    color: #666;
    font-style: italic;
    background-color: #f9f9f9;
    padding: 8px 10px;
    border-left: 3px solid #ddd;
    margin-left: 10px;
    margin-top: 5px;
}

.sub-step {
    margin: 20px 0 20px 20px;
    padding-left: 10px;
}

.sub-step-number {
    font-weight: 600;
    margin-bottom: 8px;
    color: #000;
    font-size: 16px;
}

.sub-step-content {
    font-size: 15px;
    margin: 8px 0;
}

.sub-step-list {
    list-style-type: disc;
    /* 圆点列表 */
    padding-left: 25px;
    margin: 10px 0;
}

/* 按钮样式 */
.btn-explore,
.btn-next {
    border: none;
    background: transparent;
    color: #1a73e8;
    /* 蓝色按钮文字 */
    cursor: pointer;
    padding: 0;
    font-size: 14px;
    text-decoration: underline;
    /* 下划线模拟链接效果 */
}

.btn-explore:hover,
.btn-next:hover {
    color: #0d47a1;
}


.sub-step-list {
    list-style: none;
    /* 移除外层列表符号 */
    padding-left: 0;
    margin: 0;
}

.step-item {
    margin-bottom: 25px;
    /* 步骤之间的间距 */
}

.step-text {
    font-size: 16px;
    margin: 0 0 10px 0;
    color: #000000;
}

/* 操作项列表（内层黑点符号） */
.operation-list {
    list-style-type: disc;
    padding-left: 30px;
    margin: 10px 0;
}

.operation-list li {
    font-size: 14px;
    margin: 8px 0;
    color: #333;
}

/* 图片样式 */
.step-image {
    margin: 12px 0 15px 0;
    /* 图片与上下文本的间距 */
}

.imageInfo {
    width: 800px;
    box-shadow: 0px 1px 20px #eeeeee;
    margin: 50px 0px;


    img {
        width: 100%;
    }
}
</style>